import * as HomeConstants from './home.constants';

export default HomeConstants;
